import React, { Component } from 'react';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';
import { Link } from 'react-router-dom';




class Test140626 extends Component {
  state = { walletInfo: {} };
  render() {
    const { address, balance } = this.state.walletInfo;
    return (
      <div className='RosterThursday2'>
      <img className='logo' src={logo}></img>
      <br />
      <h3>Examination 14/06/2026 (Marine Martial Arts Lumpini) Results</h3>
      <br />
      <br />

        <div><Link to='/conduct-wichaic'>1. AAT  5642  MR.WICHAI	CHEEVAPITAKPHOL(PASS with Distinction)---Acquired Rank 3DAN</Link></div>
        <br />
        <div><Link to='/conduct-wannatouchp'>2. AAT  7847  MR.WANNATOUCH PRASERT(PASS with Distinction)---Acquired Rank 2KYU</Link></div>
        <br />
        <div><Link to='/conduct-jacquesp'>3. AAT  7369  MR.JACQUES DU PLESSIS(PASS)---Acquired Rank 2KYU</Link></div>
        <br />
        <div><Link to='/conduct-anantayak'>4. AAT  7749  MS.ANANTAYA	KULTANAKORN(PASS)---Acquired Rank 4KYU</Link></div>
        <br />
        <div><Link to='/conduct-karnts'>5. AAT  8007  MR.KARNT SRISUWAN(PASS)---Acquired Rank 6KYU</Link></div>
        <br />
        <div><Link to='/conduct-pakawadn'>6. AAT  8008  MR.PAKAWAD NANTAJURAPLO(PASS)---Acquired Rank 6KYU</Link></div>
        <br />
        <div><Link to='/conduct-patawank'>7. AAT  8050  MS.PATAWAN KANPLIEN(PASS)---Acquired Rank 6KYU***</Link></div>
        <br />
        <div><Link to='/conduct-kosinm'>8. AAT  8051  MR.KOSIN	MUNGCHAROEN(PASS)---Acquired Rank 6KYU***</Link></div>
        <br />
        <div><Link to='/conduct-vunqt'>9. AAT  8021  MS.NGUYEN QUYNH TRAM VU(PASS)---Acquired Rank 6KYU***</Link></div>
        <br />
        <div><Link to='/conduct-praphatpongy'>10. AAT  8038  MR.PRAPHATPONG  YOODEE(PASS)---Acquired Rank 8KYU</Link></div>
        <br />
        <div><Link to='/conduct-naras'>11. AAT  8040  MR.NARA  SINGHSATHITSUK(PASS)---Acquired Rank 8KYU</Link></div>
        <br />
        <div><Link to='/conduct-marks'>12. AAT 8041  MR.MARK SRIAPORN(PASS with Distinction)---Acquired Rank 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-marvins'>13. AAT 8042  MR.MARVIN SRIAPORN(PASS)---Acquired Rank 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-mitts'>14. AAT 8043  MR.MITT SRIAPORN(PASS)---Acquired Rank 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-pats'>15. AAT  8016  MR.PAT SUTHAPUNNAKUL(PASS)---Acquired Rank 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-jasona'>16. AAT 8053  MR.HUA YIK ANG(PASS)---Acquired Rank 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-nithiss'>17. AAT  8055  MR.NITHIS SIWATHEWINTRA(PASS)---Acquired Rank 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-phusins'>18. AAT  8056  MR.PHUSIN	SIWATHEWINTRA(PASS)---Acquired Rank 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-vaayuk'>19. AAT  8057  MR.VAAYU KHATTRI(PASS)---Acquired Rank 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-niksak'>20. AAT  8058  MR.NIKSA	KIATTHANAPIBOON(PASS)---Acquired Rank 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-phattarakritl'>21. AAT  8059  MR.PHATTARAKRIT LAPANALARPLOY(PASS)---Acquired Rank 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-paricharts'>22. AAT  8061  MS.PARICHART SRIAPORN(PASS)---Acquired Rank 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-phuphumj'>23. AAT  8062  MR.PHUPHUM JIRACHANKIAT(PASS)---Acquired Rank 10KYU</Link></div>
        <br />








        <div>
          Thailand's Aikido Association Registration...
        </div>
          <br />
          <br />
        <div>Powered by</div><img className='logo2' src={logo2}></img><div>New Wave Consulting Group</div>
      </div>
    );
  }
}
export default Test140626;
